
import { inject, InjectionToken, DOCUMENT } from '@angular/core';

export const APP_WINDOW = new InjectionToken<Window>('APP_WINDOW', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);

    if (!defaultView) {
      throw new Error('Window is not available');
    }

    return defaultView;
  },
});
